import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes, FaLinkedin } from 'react-icons/fa';

const Header = ({ bgColor = '#121212' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  // Detect scroll (only for desktop)
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);


  return (
 <header
      className={`text-white z-50 fixed top-0 left-0 w-full transition-all duration-500
        ${isScrolled
          ? 'backdrop-blur-lg shadow-md md:top-4 md:left-12 md:w-[93%] md:rounded-[20px] top-4 left-3 w-[93%] rounded-[20px]'
          : 'shadow-none '
        }`}
      style={{
        backgroundColor: isScrolled
          ? `${bgColor}B3`  
          : `${bgColor}4D`, 
      }}
>
      <div className="flex items-center justify-between py-4 px-6 lg:px-7 ">
        <Link to="/" className="text-2xl font-bold">
          {/* <span className="text-white">Tech</span>
          <span className="text-green-400">Xplore</span> */}
          <img src="/company_img/logo.svg"  alt='Techxplore – Complete IT Solutions Including Android, iOS, and Enterprise Applications' className='mb-1'></img>
        </Link>

       <button onClick={toggleMenu} className="md:hidden relative flex flex-col justify-between w-6 h-6 focus:outline-none">
         <span className="block h-[3px] w-3 bg-white rounded-sm self-end transition-all duration-300"></span>
        <span className="block h-[3px] w-[24px] bg-white rounded-sm transition-all duration-300"></span>
        <span className="block h-[3px] w-3 bg-white rounded-sm self-start transition-all duration-300"></span>
      </button>

        {/* Desktop Menu */}
      <nav className=" space-x-1 hidden md:flex ">
        {['services', 'case-studies', 'about-us',  'contact'].map((route) => {
          const isContact = route === 'contact';
          return (
            <Link
              key={route}
              to={`/${route}`}
              className={` px-6 py-1 text-body font-normal font-roboto transition duration-300 text-[#FFFFFF] ${
                isContact ? 'bg-[#FFFFFF] text-[#000000] rounded-[50px] border border-transparent hover:text-white hover:bg-transparent hover:border-white'  : ''
              }`}
            >
              {route.split('-').map(w => w[0].toUpperCase() + w.slice(1)).join(' ')}
            </Link>
          );
        })}
      </nav>
      </div>

      {/* Mobile Sidebar Menu */}
       {isOpen && (
      <div
        className={`fixed inset-0  w-[100%] h-screen bg-[#00E599] text-black z-[100] overflow-y-auto `}
      >
        <div className="flex justify-between items-center px-6 py-4 border-b border-black">
          <Link to="/" className="text-2xl font-bold" onClick={toggleMenu}>
             <img src="/company_img/logo_sm.svg" alt='Techxplore provides a unified digital strategy that includes enterprise app architecture, mobile-first development, responsive web platforms, and seamless UI/UX design to deliver functional and beautiful user experiences.' className='h-10'></img>
          </Link>
         <button onClick={toggleMenu} className="relative w-6 h-6 focus:outline-none">
        <span className="absolute top-1/2 left-0 w-full h-[2px] bg-black transform rotate-45"></span>
        <span className="absolute top-1/2 left-0 w-full h-[2px] bg-black transform -rotate-45"></span>
        </button>
        </div>

        <nav className="flex flex-col px-6 py-16 ">
          {['Services', 'Case studies', 'About us', 'Contact'].map((label, i) => (
            <Link
              key={i}
              to={`/${label.toLowerCase().replace(' ', '-')}`}
              onClick={toggleMenu}
               className="font-roboto font-normal text-[25px] leading-[57px] tracking-[0%] hover:text-white transition"
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* Footer icons */}
        <div className="absolute left-6 flex space-x-4 items-center">
           <img src="/icons/x.com_icon.svg" alt="Menu Toggle" />
           <img src="/icons/linkedin_icon.svg" alt="Menu Toggle" />
        </div>
      </div>
       )}
    </header>
  );
};

export default Header;
